global.antRouter = ""; //全局的路由
// 使用id4更改这里2
global.IS_IDS4 = false; // 默认false，表示使用JWT模式，如果true，表示使用ids4

global.UploadPath = "http://180.110.202.114:6002/api/File/UploadForInvoice/";
// global.UploadPath = "http://58.220.5.124:7001/api/File/UploadForInvoice/";
global.testUploadPath = "http://localhost:8081/api/File/UploadForInvoice/";
global.DownPath = "http://180.110.202.114:6002/api/File/DownFile/";
// global.DownPath = "http://58.220.5.124:7001/api/File/DownFile/";
global.testDownPath = "http://localhost:8081/api/File/DownFile/";
global.UploadPath2 = "http://180.110.202.114:6002/api/File/Upload/";
// global.UploadPath2 = "http://58.220.5.124:7001/api/File/Upload/";
global.testUploadPath2 = "http://localhost:8081/api/File/Upload/";
global.DownPath2 = "http://180.110.202.114:6002/api/File/Get/";
// global.DownPath2 = "http://58.220.5.124:7001/api/File/Get/";
global.testDownPath2 = "http://localhost:8081/api/File/Get/";
